import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../components/Helpers/helpers";

export const userApi = createApi({
  reducerPath: "userApi",

  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),

  tagTypes: ["Users", "UserDetail", "Roles", "Organisations"],

  endpoints: (builder) => ({
    //  GET USER LIST
    getUserList: builder.query({
      query: (params = {}) => {
        const query = new URLSearchParams(params).toString();
        return `/user?${query}`;
      },
      providesTags: ["Users"],
    }),

    //  DELETE USER
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `/user/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Users"],
    }),

    //  GET ROLE LIST
    getRoleList: builder.query({
      query: () => `/role`,
      providesTags: ["Roles"],
    }),

    //  GET ORGANISATION LIST
    getOrganisationList: builder.query({
      query: () => `/organisation`,
      providesTags: ["Organisations"],
    }),

    //  GET USER DETAIL
    getUserDetail: builder.query({
      query: (id) => `/user/${id}`,
      providesTags: (r, e, id) => [{ type: "UserDetail", id }],
    }),

    //  UPDATE USER DETAIL
    updateUserDetail: builder.mutation({
      query: ({ userId, payload }) => ({
        url: `/user/update/${userId}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Users", "UserDetail"],
    }),

    //  ADD USER
    addUser: builder.mutation({
      query: (payload) => ({
        url: `/user`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Users"],
    }),

    //  EDIT USER
    editUser: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/user/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["Users", "UserDetail"],
    }),
    getUserByUserId: builder.query({
      query: ({ OrganisationID, UserID }) =>
        `/user/get-user?OrganisationID=${OrganisationID}&UserID=${UserID}`,

      providesTags: (r, e, UserID) => [{ type: "UserDetail", id: UserID }],
    }),
  }),
});

export const {
  useGetUserListQuery,
  useDeleteUserMutation,
  useGetRoleListQuery,
  useGetOrganisationListQuery,
  useGetUserDetailQuery,
  useUpdateUserDetailMutation,
  useAddUserMutation,
  useEditUserMutation,
  useGetUserByUserIdQuery,
} = userApi;
